<template>
    <div class="gs-app gs-integrations">
        <affiliate-workspace :sections="pricePointsTabs" :current="pricePointsTab" :error-sections="pricePointsErrorTabs" label="Price points" @select="handlePricePointsTabChange">
        <div class="gs-integrations__panel bg-white rounded p-2 mb-2">
            <div v-for="(pricePoint, index) in integration.price_points" :key="index">
                <div v-if="pricePointsTab ===
                    'data_sharing_product_price_point_' + pricePoint.id
                    " class="gs-integrations__price-point flex flex-col w-full">
                    <div class="gs-integrations__content flex flex-col w-full bg-white mb-2">
                        <div v-if="pluginSiteData.integrations.length > 0 && availableIntegrations.length > 0">
                            <div class="gs-integrations__collection flex flex-col">
                                <div class="gs-integrations__toolbar flex flex-row-reverse w-full">
                                    <gd-button size="auto" variant="primary" class="gs-integrations__add mr-4"
                                        @click="showPostSaleIntegrationBox(index)">{{
                                            $t('frontend_product_step8_add_new')
                                        }}</gd-button>
                                </div>
                                <div v-if="pricePoint.affiliate_integration &&
                                        pricePoint.affiliate_integration.length > 0
                                        " class="gs-integrations__list mt-6">
                                    <div v-for="(
                                postSaleIntegration, postSaleIntegrationIndex
                              ) in pricePoint.affiliate_integration" :key="postSaleIntegrationIndex"
                                        class="gs-integrations__row flex flex-col mt-4">
                                        <div class="gs-integrations__record flex flex-row" :class="{
                                            'border-t border-grey-400 border-solid pt-4':
                                                postSaleIntegrationIndex > 0,
                                        }">
                                            <div class="gs-integrations__destination w-1/12 mr-8">{{ $t('frontend_groovesell_addTo') }}</div>
                                            <div class="gs-integrations__details-wrap flex flex-row w-11/12">
                                                <div class="gs-integrations__metadata w-3/4 flex flex-col">
                                                    <div class="gs-integrations__field gs-integrations__field--type flex flex-row">
                                                        <div class="gs-integrations__label font-bold mr-2">
                                                            {{ $t('frontend_product_step8_type') }}
                                                        </div>
                                                        <div class="gs-integrations__value">
                                                            {{
                                                                postSaleIntegration.platform
                                                                    .charAt(0)
                                                                    .toUpperCase() +
                                                                postSaleIntegration.platform.slice(1)
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div v-for="(
                                        postSaleIntegrationConfig,
                                                postSaleIntegrationConfigIndex
                                      ) in postSaleIntegration.config" :key="postSaleIntegrationConfigIndex"
                                                        class="gs-integrations__field flex flex-row">
                                                        <div class="gs-integrations__label font-bold mr-2">
                                                            {{ postSaleIntegrationConfig.label }} :
                                                        </div>
                                                        <div class="gs-integrations__value">
                                                            {{ postSaleIntegrationConfig.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="gs-integrations__actions w-1/4 flex flex-row justify-end pr-4">
                                                    <gd-button size="icon" variant="primary"
                                                        :title="$t('frontend_groovesell_delete_integration')"
                                                        :aria-label="$t('frontend_groovesell_delete_integration')"
                                                        class="gs-integrations__delete mr-2"
                                                        @click="
                                                            deletePostSaleIntegration(
                                                                index,
                                                                postSaleIntegrationIndex
                                                            )
                                                            ">
                                                        <trash-icon class="w-5 h-5 fill-current" />
                                                    </gd-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="gs-integrations__empty mt-6">
                                    <label class="text-grey-dark">{{
                                        $t('frontend_product_step8_no_integrations')
                                    }}</label>
                                </div>
                            </div>
                        </div>
                        <div v-else class="gs-integrations__empty">
                            <label class="text-grey-dark">{{
                                $t('frontend_product_step8_no_integrations_added')
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </affiliate-workspace>
    </div>
</template>
<script>
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
import auth from '@groovepages/gd-lib/auth';
import TrashIcon from '@/assets/images/icons/TrashIcon.svg';

export default {
    components: { AffiliateWorkspace,
        TrashIcon,
    },
    props: {
        integration: {
            type: Object,
            required: true,
        },
        pricePointsTabs: {
            type: Array,
            required: true,
        },

        pricePointsTab: {
            type: String,
            required: true,
        },
        handlePricePointsTabChange: {
            type: Function,
            required: true,
        },

        showPostSaleIntegrationBox: {
            type: Function,
            required: true,
        },

    },
    computed: {
        pluginSiteData() {
            return this.$store.getters.pluginSiteSettings;
        },
        availableIntegrations() {
            const user = auth.authenticatedUser();
            if (user.metadata && user.metadata.integrations) {
                const integrations = [];
                user.metadata.integrations.map((value, key) => {
                    const integrationType = value.type.split('-')[0];
                    const integrationPlugin = `${integrationType}-component`;
                    if (
                        integrations.findIndex((x) => x.value == integrationPlugin) == -1
                    ) {
                        integrations.push({
                            text:
                                integrationType.charAt(0).toUpperCase() +
                                integrationType.slice(1),
                            value: integrationPlugin,
                        });
                    }
                });

                return integrations;
            }

            return [];
        },
        pricePointsErrorTabs() {
            return [];
        },
    },
    methods: {

        deletePostSaleIntegration(pricePointIndex, postSaleIntegrationIndex) {
            return;
        },

    }
}
</script>

<style scoped>
.gs-integrations {
    min-width: 0;
    color: var(--gs-foreground);
}

.gs-integrations__tabs {
    min-width: 0;
    overflow-x: auto;
    overscroll-behavior-x: contain;
}

.gs-integrations ::v-deep .gs-default-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0 12px;
}

.gs-integrations ::v-deep .gs-default-tabs-item {
    margin-right: 0;
    min-width: 0;
    white-space: normal;
}

.gs-integrations ::v-deep .gs-default-tabs-item:focus-visible {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
}

.gs-integrations__panel {
    min-width: 0;
    padding: 0;
    background: transparent;
}

.gs-integrations__toolbar {
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 4px;
}

.gs-integrations ::v-deep .gs-integrations__add {
    min-height: 40px;
    margin-right: 0;
    color: var(--gs-primary);
    background: var(--gs-surface);
    border: 1px solid var(--gs-primary);
    border-radius: var(--gs-radius-md);
    box-shadow: none;
}

.gs-integrations ::v-deep .gs-integrations__add:hover,
.gs-integrations ::v-deep .gs-integrations__add:focus-visible {
    color: var(--gs-primary);
    background: var(--gs-primary-soft);
}

.gs-integrations__row {
    min-width: 0;
}

.gs-integrations__record {
    display: grid;
    grid-template-columns: minmax(88px, 0.16fr) minmax(0, 1fr);
    gap: 16px;
    min-width: 0;
    padding: 16px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
}

.gs-integrations__record.border-t {
    border-top: 1px solid var(--gs-border);
}

.gs-integrations__destination {
    width: auto;
    margin-right: 0;
    color: var(--gs-muted-foreground);
    font-size: 13px;
    font-weight: 700;
    line-height: 1.5;
}

.gs-integrations__details-wrap {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 16px;
    width: auto;
    min-width: 0;
}

.gs-integrations__metadata {
    width: auto;
    min-width: 0;
    gap: 8px;
}

.gs-integrations__field {
    display: grid;
    grid-template-columns: minmax(112px, max-content) minmax(0, 1fr);
    gap: 8px;
    min-width: 0;
    color: var(--gs-foreground);
    font-size: 14px;
    line-height: 1.5;
}

.gs-integrations__label {
    margin-right: 0;
    color: var(--gs-muted-foreground);
}

.gs-integrations__value {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.gs-integrations__actions {
    width: auto;
    padding-right: 0;
    align-items: flex-start;
}

.gs-integrations ::v-deep .gs-integrations__delete {
    width: 44px;
    min-width: 44px;
    height: 44px;
    min-height: 44px;
    margin-right: 0;
    color: var(--gs-danger);
    background: transparent;
    border: 1px solid transparent;
    border-radius: var(--gs-radius-md);
    box-shadow: none;
}

.gs-integrations ::v-deep .gs-integrations__delete:hover,
.gs-integrations ::v-deep .gs-integrations__delete:focus-visible {
    color: var(--gs-danger);
    background: var(--gs-surface);
    border-color: var(--gs-danger-border);
}

.gs-integrations ::v-deep .gs-integrations__add:focus-visible,
.gs-integrations ::v-deep .gs-integrations__delete:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 3px var(--gs-ring);
}

@media (max-width: 640px) {
    .gs-integrations__tabs {
        margin-right: -12px;
        margin-left: -12px;
        padding-right: 12px;
        padding-left: 12px;
    }

    .gs-integrations__toolbar {
        display: flex;
    }

    .gs-integrations ::v-deep .gs-integrations__add {
        width: 100%;
        min-height: 44px;
        justify-content: center;
    }

    .gs-integrations__record,
    .gs-integrations__details-wrap {
        grid-template-columns: minmax(0, 1fr);
    }

    .gs-integrations__record {
        gap: 12px;
        padding: 14px;
    }

    .gs-integrations__destination {
        font-size: 12px;
        letter-spacing: 0.04em;
        text-transform: uppercase;
    }

    .gs-integrations__field {
        grid-template-columns: minmax(0, 1fr);
        gap: 2px;
    }

    .gs-integrations__actions {
        justify-content: flex-start;
    }
}
</style>
